import { McLoadingIndicator } from '@maersk-global/mds-react-wrapper';

interface AppLoadingIndicatorProps {
  isFullScreen?: boolean;
}

const AppLoadingIndicator = ({ isFullScreen }: AppLoadingIndicatorProps) => {
  if (!isFullScreen) {
    return (
      <div className="loading">
        <McLoadingIndicator />
      </div>
    );
  }

  return (
    <div
      className="mds-flex mds-flex-column mds-neutral__background-color mds-neutral__on-background-color"
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        padding: '2rem',
      }}
    >
      <div className="loading">
        <McLoadingIndicator />
      </div>
    </div>
  );
};

export default AppLoadingIndicator;
